import { ContactOfFilter } from '../../../components/organisms/contactsFilters/components/filters/contactOf';
import { HireDateFilter } from './filters/hireDateFilter';
import { TeamInvolvementFilter } from './filters/teamInvolvementFilter';
import { ReviewStatusFilter } from './filters/reviewStatusFilter';
import { SourceFilter } from './filters/sourceFilter';
import { FirstSeenFilter } from './filters/firstSeenFilter';
import { HiresCompanyFilter } from './filters/hiresCompanyFilter';

export const createHiresFilterGroups = ({ filters, setFilters }) => [
  {
    id: 'network',
    title: 'Network',
    show: true,
    filters: [
      {
        id: 'importerIds',
        Component: ContactOfFilter,
        props: {
          value: filters.importerIds,
          setFilters,
        },
        show: true,
      },
      {
        id: 'sources',
        Component: SourceFilter,
        props: {
          value: filters.sources,
          setFilters,
        },
        show: true,
      },
      {
        id: 'firstSeen',
        Component: FirstSeenFilter,
        props: {
          value: filters.firstSeen,
          setFilters,
        },
        show: true,
      },
    ],
  },
  {
    id: 'company',
    title: 'Company',
    show: true,
    filters: [
      {
        id: 'companyName',
        Component: HiresCompanyFilter,
        props: {
          companyName: filters.companyName,
          companyDomain: filters.companyDomain,
          setFilters,
        },
        additionalCountKeys: ['companyDomain'],
        show: true,
      },
    ],
  },
  {
    id: 'hire',
    title: 'Hire',
    show: true,
    filters: [
      {
        id: 'teamInvolvement',
        Component: TeamInvolvementFilter,
        props: {
          value: filters.teamInvolvement,
          setFilters,
        },
        show: true,
      },
      {
        id: 'reviewStatus',
        Component: ReviewStatusFilter,
        props: {
          value: filters.reviewStatus,
          setFilters,
        },
        show: true,
      },
      {
        id: 'hireDate',
        Component: HireDateFilter,
        props: {
          value: filters.hireDate,
          setFilters,
        },
        show: true,
      },
    ],
  },
];
